import { pageNotFound } from 'Bomdisoft/translations';
import { html, renderButton } from '@bomdisoft/components/native';
import { getLanguageFromLocale, returnHome } from '@bomdisoft/translations';

const HOME_ANNOTATION = 'Go to the home page from a missing page';

export const renderNotFoundPage = ({ lang }: { lang: string }) => {
  const language = getLanguageFromLocale(lang);
  return html`<div class="landing-not-found-root"><p class="landing-not-found-code">404</p><p class="landing-not-found-message">${pageNotFound[language]}</p>${renderButton({ attributes: { 'data-prodantix': HOME_ANNOTATION }, children: returnHome[language], className: 'landing-not-found-button', variant: 'contained' })}</div>`;
};

/** The missing page speaks the reader's browser language, as the React page did, and its button goes home. */
export const delegateNotFoundPage = (root: ParentNode, { browserLanguage, navigate }: { browserLanguage: string; navigate: (path: string) => void }) => {
  const page = root.querySelector('.landing-not-found-root');
  if (page === null) return () => {};
  const language = getLanguageFromLocale(browserLanguage);
  const message = page.querySelector('.landing-not-found-message');
  const button = page.querySelector<HTMLButtonElement>(`button[data-prodantix="${HOME_ANNOTATION}"]`);
  if (message) message.textContent = pageNotFound[language];
  if (button) button.textContent = returnHome[language];
  const handleClick = () => navigate('/');
  button?.addEventListener('click', handleClick);
  return () => button?.removeEventListener('click', handleClick);
};
